import {
  Outlet,
  Route,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import Order from 'src/pages/order';
import HomeScreen from 'src/pages/order/HomeScreen';
import ListFoodSet from 'src/pages/order/ListFoodSet';
import ListMenuSet from 'src/pages/order/ListMenuSet';
import OrderBill from 'src/pages/order/OrderBill';
import OrderCheckout from 'src/pages/order/OrderCheckout';
import OrderConfirm from 'src/pages/order/OrderConfirm';
interface IProps {
  children: JSX.Element | JSX.Element[];
}

const Layout: React.FC<IProps> = props => {
  return (
    <>
      {/* <Nav /> */}
      <main>{props.children}</main>
    </>
  );
};

const MainLayout = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <Layout>
          <Outlet />
        </Layout>
      }>
      {/* welcome screen */}
      <Route index path="home" element={<HomeScreen />} />
      <Route index path="home/:shopId" element={<HomeScreen />} />
      {/* QR code printed for table */}
      <Route index path="home/:shopId/table/:code" element={<HomeScreen />} />

      {/* Shows categories */}
      <Route path="order/:shopId/index" element={<Order />} />
      <Route path="order/:shopId/listMenuSet" element={<ListMenuSet />} />
      <Route path="order/:shopId/listFoodSet" element={<ListFoodSet />} />
      <Route path="order/:shopId/orderBill" element={<OrderBill />} />
      <Route path="order/:shopId/orderCheckout" element={<OrderCheckout />} />
      <Route path="order/:shopId/orderConfirm" element={<OrderConfirm />} />
    </Route>,
  ),
);

export default MainLayout;
